/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LastServiceDate { 
    service_last_day?: number;
    service_last_month?: number;
    service_last_year?: number;
}

